import React from 'react';

import { Form } from 'antd';
import Input from 'components/forms/Input';
import Button from 'components/forms/Button';

const NewSaveForm = ({ formRef, onChangeMode }) => (
    <Form
        form={formRef}
        labelCol={{
            span: 5,
        }}
        wrapperCol={{
            span: 15,
        }}
    >
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
            <Input />
        </Form.Item>
        <Form.Item label="Description" name="description">
            <Input.TextArea />
        </Form.Item>
        <Button block type="link" onClick={onChangeMode}>
            I want to update an existing save instead
        </Button>
    </Form>
);

export default NewSaveForm;
